import type { QuickPromptChipsBlockProps } from "../types";
import { QuickPromptChips } from "./QuickPromptChips";
import { QuickPromptChipsSkeleton } from "../states/QuickPromptChipsSkeleton";

export function QuickPromptChipsBlock({
  isLoading = false,
  ...viewProps
}: QuickPromptChipsBlockProps) {
  if (isLoading) {
    return <QuickPromptChipsSkeleton />;
  }

  return <QuickPromptChips {...viewProps} />;
}
